module.exports = __webpack_public_path__ + "static/after-f86673f1311eca54616c6064f98317ed.png";